import axios, { AxiosResponse } from 'axios';

const BASE_URL = import.meta.env.VITE_API_ENDPOINT || 'https://smlr.reshci-c-uw2.cloudos.autodesk.com/api';

export const getAllMeetings = async(): Promise<AxiosResponse<MeetingMetaData[]>> => {
    try {
        const meetings: AxiosResponse<MeetingMetaData[]> = await axios.get(`${BASE_URL}/meetings`);
        return meetings;
    } catch (err) {
        throw err;
    }
}

export const getMeetingMetadata = async(meetingId: string): Promise<AxiosResponse<MeetingMetaData>> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}`;
        const meeting: AxiosResponse<MeetingMetaData> = await axios.get(requestURL);
        return meeting;
    } catch (err) {
        throw err;
    }
}

export const createMeeting = async(meetingId :string , meetingData : MeetingMetaData) => {
    try {
        const requestURL = `${BASE_URL}/createMeeting/update`;
        const data = await axios.post(requestURL, {meeting_id : meetingId, MeetingData : meetingData }).then((response) => response.data.meetingId);
        return data
        
        }catch(err){
        throw(err)
    }
}

export const updateMeetingEndTime = async(meetingId : string, endTime: any): Promise<void> => {
    try{
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/endTime`; 
        await axios.put(requestURL, { endTime: endTime });
    }catch(err){
        throw(err)
    }
}

export const updateMeetingStartTime = async(meetingId : string, startTime: any) => {
    try{
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/startTime`; 
        await axios.put(requestURL, { startTime: startTime });
    }catch(err){
        throw(err)
    }
}

export const updateMeetingDisplay =  async(meetingId : string, display: boolean) => {
    try{
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/displaySeconds`; 
        await axios.put(requestURL, { display: display });
    }catch(err){
        throw(err)
    }
}

export const updateMeetingCursor = async(meetingId: string, cursor: number): Promise<void> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/cursor`;
        await axios.put(requestURL, { cursor: cursor });
    } catch (err) {
        throw err;
    }
}

export const getMeetingPresenters = async(meetingId: string): Promise<AxiosResponse<Presenter[]>> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/presenters`;
        const presenters: AxiosResponse<Presenter[]> = await axios.get(requestURL);
        return presenters;
    } catch (err) {
        throw err;
    }
}

export const addMeetingPresenter = async(meetingId: string, presenter: Presenter): Promise<void> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/presenters/`;
        await axios.post(requestURL, { presenter: presenter });
    } catch (err) {
        throw err;
    }
}

export const deleteMeetingPresenter = async(meetingId: string, presenter: Presenter): Promise<void> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/${encodeURIComponent(presenter.id)}`;
        await axios.delete(requestURL);
    } catch (err) {
        throw err;
    }
}

export const updateMeetingPresenter = async(meetingId: string, presenter: Presenter): Promise<void> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/presenters/${encodeURIComponent(presenter.id)}`;
        await axios.put(requestURL, { presenter: presenter });
    } catch (err) {
        throw err;
    }
}

export const updateAllMeetingPreseters = async(meetingId: string, presenters: Presenter[]): Promise<void> => {
    try {
        await Promise.all(presenters.map((presenter) => updateMeetingPresenter(meetingId, presenter)));
    } catch (err) {
        throw err;
    }
}

export const getBonusTime = async(meetingId: string): Promise<AxiosResponse<Presenter>> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/bonusTime`;
        const bonusTime: AxiosResponse<Presenter> = await axios.get(requestURL);
        return bonusTime;
    } catch (err) {
        throw err;
    }
}

export const putBonusTime = async(meetingId: string, bonusTime: Presenter): Promise<void> => {
  try {
      const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/bonusTime`;
      await axios.post(requestURL, { bonusTime: bonusTime });
  } catch (err) {
      throw err;
  }
}

export const updateBonusTime = async(meetingId: string, bonusTime: Presenter): Promise<void> => {
    try {

        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/bonusTime`;
        await axios.put(requestURL, { bonusTime: bonusTime });
    } catch (err) {
        throw err;
    }
}

export const updatePresenterOrder = async(meetingId: string, presenterOrder: string[]): Promise<void> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/presenterOrder`;
        await axios.put(requestURL, { presenterOrder: presenterOrder });
    } catch (err) {
        throw err;
    }
}

export const presenterChange = async(meetingId: string, presenterOrder: string[], bonusTime: Presenter ) : Promise<void> =>{
    try{
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/presenterChange`;
        await axios.put(requestURL, { presenterOrder: presenterOrder, bonusTime : bonusTime });
    } catch (err){
        throw err;
    }
}

export const updateMeetingDuration = async(meetingId: string, duration: number): Promise<void> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/duration`;
        await axios.put(requestURL, { duration: duration });
    } catch (err) {
        throw err;
    }
}


export const updateMeetingDebug = async(meetingId: string, debug: boolean): Promise<void> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/debug`;
        await axios.put(requestURL, { debug: debug });
    } catch (err) {
        throw err;
    }
}

export const updateMeetingIndexToStealFrom = async(meetingId: string, index: number): Promise<void> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/indexToStealFrom`;
        await axios.put(requestURL, { indexToSteal: index });
    } catch (err) {
        throw err;
    }
}


export const getTimeBuffer = async(meetingId: string) : Promise<any> =>  {
    try{
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/timeBuffer`;  
        const serverTime : AxiosResponse<any> = await axios.get(requestURL);
        return serverTime
    } catch (err){
        throw err;
    }
}


//KENDRA: todo generic log command

export const getArchivedMeetings = async(meetingId: string): Promise<AxiosResponse<MeetingMetaData>> => {
    try {
        const requestURL = `${BASE_URL}/meetings/${encodeURIComponent(meetingId)}/archivedMeetings`;
        const archivedPKList: AxiosResponse<any> = await axios.get(requestURL);
        return archivedPKList;
    } catch (err) {
        throw err;
    }
}

export const DEFAULT_BONUS_TIME: Presenter = {
  name: 'Bonus Time',
  id: '-',
  description: '',
  flight: 0,
  priority: -1,
  slotType: "Break",
  initialDuration: 0,
  currentDuration: 0,
  elapsedTime: 0,
  startTime: "",
  endTime: "",
  dbElapsedTime: 0
}

export const DEFAULT_EMPTY_PRESENTER: Presenter = {
  id: "",
  name: "",
  description: "",
  initialDuration: 5, 
  currentDuration: 5, 
  elapsedTime: 0,
  flight: 3,
  startTime: "",
  endTime: "",
  dbElapsedTime: 0,
  priority: 1,
  slotType: 'Presenter'
};
